export function extractLibraryFileId(imageUrl) {
  const regex = /uploads\/\d+\/(\d+)\//;
  const match = imageUrl.match(regex);
  return match ? match[1] : null;
}
